import { parseTTL } from './parse-ttl'
import { formatTTL } from './format-ttl'

/**
 * TTL (Time-to-Live) yardımcı servis
 * Desteklenen formatlar: "30s", "5m", "2h", "1d", "1w"
 */
export const ttlService = {
  parse: parseTTL,
  format: formatTTL
}

export {
  parseTTL,
  formatTTL
}